<template>
  <div class="mb-4">

    <!--#region -- Content ---->

    <div class="stage-header border-bottom mb-4">
      <!--#region Header-->
      <div class="caption-label">List View (Please router to correct page)</div>
      <!--#endregion Header-->
    </div>
    <!--#endregion-->

    <div style="margin-bottom: 6rem;">
      <!--#region PN/MPS Quotation-->
      <div class="stage-body-rsm-comments-and-conclusions border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div>Result</div>
        </div>
       
        <div>
          <b-table :fields="quotationFields" :items="fakeItems"
                   small
                   thead-class="thead-light text-dark"
                   :busy="searching"
                   style="width: calc(100% - 10px)">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(action)="data">
              <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit" @click="$emit('quoteItemModal', data.item)"></button>
              <!--               <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-delete" @click="$emit('removeQuoteItem',data.item)"></button> -->

            </template>


          </b-table>
        </div>
      </div>
      <!--#endregion-->
    </div>

    <!--#endregion-->



  </div>
</template>
<script>
  export default {
    data() {
      return {
        ftieId: '15301',
        nreId: '2696',
        fakeCustomer: 'US Army - Fort Detrick',
        fakeModelName: 'S410G4',
        breadcrumbItems: [
          {
            text: 'Customization Process',
            disabled: true
            //to: { name: 'home' }
          },
          {
            text: 'Ticket #15301',
            //to: { name: 'home' }
          },
          {
            text: 'Request Form',
            //to: { name: 'home' }
          },
          {
            text: 'SKU/NRE/PN Maintain',
            active: true
          }
        ],
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        searching: false,
        testDataforSync: '',
        quotationFields: [
          { key: 'real_sku_no', label: 'SKU#', thClass: 'align-middle', sortable: true },
          { key: 'ftie_id', label: 'FTIE ID', thClass: 'align-middle', sortable: true },
          { key: 'sku_id', label: 'Ref SKU ID', thClass: 'align-middle', sortable: true },
          { key: 'country', label: 'Country', thClass: 'align-middle', sortable: true },
          {
            key: 'sku_description', label: 'SKU Description',
            thClass: 'align-middle', thStyle: { width: "30%" },
            sortable: true
          },
          { key: 'customization_pn', label: 'P/N', thClass: 'align-middle', sortable: true },
          { key: 'create_date', label: 'Create Date', thClass: 'align-middle', sortable: true },
          { key: 'last_edit_date', label: 'Last Edit Date', thClass: 'align-middle', sortable: true },
          {
            key: 'action',
          }
        ],
        sfdcProductFields: [
          { key: 'product_type', label: 'Product Type', thClass: 'align-middle', sortable: true },
          { key: 'customization_sku_id', label: 'Customization SKU ID', thClass: 'align-middle', sortable: true },
          { key: 'mps_date', label: 'MPS Date', thClass: 'align-middle', sortable: true },
          { key: 'mps_status', label: 'MPS Status', thClass: 'align-middle', sortable: true },
          { key: 'custom_level', label: 'Custom Level', thClass: 'align-middle', sortable: true },
          { key: 'customization_pn', label: 'P/N', thClass: 'align-middle', sortable: true },
          { key: 'qty_type', label: 'Qty/Type', thClass: 'align-middle', sortable: true },
          { key: 'last_edit_date', label: 'Last Edit Date', thClass: 'align-middle', sortable: true }, ///
          {
            key: 'action',
          }
        ],

        fakeItems: [
          {
            real_sku_no: 1996, ftie_id: '15301',
            sku_id: 'TD98Y2DA519X', country: 'United States',
            sku_description: 'T Series - Intel Atom Processor x7-Z8750, 8.1+Webcam, Microsoft Windows 10 Pro x64 with 4GB RAM, 128GB eMMC, Sunlight Readable',
            customization_pn: '52621449E00B',
            create_date: '2022/4/15',
            last_edit_date: '2022/4/19',
            customer: 'DSCA - Defense Security Cooperation Agency',
            opty_name: 'DSCA-GICHL-ZX70G2-(10)',
            action: null,
          },
          {
            real_sku_no: 1995, ftie_id: '15301',
            sku_id: 'TD98Y2DA519X', country: 'United States',
            sku_description: 'T Series - Intel Atom Processor x7-Z8750, 8.1+Webcam, Microsoft Windows 10 Pro x64 with 4GB RAM, 128GB eMMC, Sunlight Readable (LCD+Touchscreen+Stylus), US Power cord, 8M Rear Camera, Wifi (AX200) + BT + 4G LTE (US/EU)',
            customization_pn: '52621449E00C',
            create_date: '2022/3/15',
            last_edit_date: '2022/3/19',
            customer: 'DSCA - Defense Security Cooperation Agency',
            opty_name: 'DSCA-GICHL-ZX70G2-(10)',
            action: null,
          },
          {
            real_sku_no: 1990, ftie_id: '15301',
            sku_id: 'SL4DZFAFAD9X', country: 'United States',
            sku_description: 'S Series - Intel Core i7-8565U Processor 1.8 GHz, 14, Microsoft Windows 10 Pro x64 with 8GB RAM, 512GB SSD, STD LCD, US KBD+China Power cord, Membrane KBD, Wifi+BT',
            customization_pn: '52621449E00S',
            create_date: '2022/2/15',
            last_edit_date: '2022/2/19',
            customer: 'DSCA - Defense Security Cooperation Agency',
            opty_name: 'DSCA-GICHL-ZX70G2-(10)',
            action: null,
          },
          {
            real_sku_no: 1989, ftie_id: '15301',
            sku_id: 'Z1C72XDI5O9X', country: 'United States',
            sku_description: 'Z Series - Qualcomm Snapdragon 660 Octa-core 1.95 GHz, W/ 8MP Webcam, Android + 4GB RAM + 64GB Storage, Sunlight Readable LCD+Touchscreen, EU ＆ UK Power Cord, 12MP Rear Camera, WIFI + BT+ GPS / Glonass + 4G LTE (EM7455), JAE Docking Connector',
            customization_pn: '52621449E00A',
            create_date: '2022/1/15',
            last_edit_date: '2022/1/19',
            customer: 'DSCA - Defense Security Cooperation Agency',
            opty_name: 'DSCA-GICHL-ZX70G2-(10)',
            action: null,
          },
          /*
          {
            real_sku_no: 1987, ftie_id: '15301',
            sku_id: 'UM22T6VIXD9X', country: 'United States',
            sku_description: 'U Series - Intel Core i5-10210U Processor, With Webcam + High Capacity Battery (1-pack), Microsoft Windows 10 Pro x64 with 16GB RAM, 512GB PCIe SSD, Sunlight Readable Full HD LCD + Touchscreen + Hard Tip stylus + Rear Camera, EU ＆ UK Power Cord, WIFI + BT',
            customization_pn: '52621449E00B',
            create_date: '2021/12/15',
            last_edit_date: '2021/12/19',
            customer: 'DSCA - Defense Security Cooperation Agency',
            opty_name: 'DSCA-GICHL-ZX70G2-(10)',
            action: null,
          }
           */

        ],
        fakeSfdcItems: [
          {
            product_type: 'System',
            customization_sku_id: 'TD98Y2DA519X',
            mps_date: '2022/4/15', mps_status: 'Approved',
            custom_level: '2 Selected, 2, Light',
            customization_pn: '52621449E00B',
            qty_type: '200/Parts',
            last_edit_date: '2022/4/19',
            action: null,
          },
          {
            product_type: 'System',
            customization_sku_id: 'SL4DZFAFAD9X',
            mps_date: '2022/4/15', mps_status: 'Approved',
            custom_level: '1 Selected, 1, Light',
            customization_pn: '52621449E00S',
            qty_type: '120/Parts',
            last_edit_date: '2022/4/20',
            action: null,
          },
        ],

        syncModalFields: [
          { key: 'unique_pn', label: 'Unique P/N', thClass: 'align-middle', sortable: true },
          { key: 'description', label: 'Description', thClass: 'align-middle', sortable: true },
          {
            key: 'action', label: 'Action',
            thClass: 'align-middle',
            thStyle: {
              display: 'none'
            },
            sortable: false
          },
        ],

        syncModalItems: [
          { unique_pn: '3449145D0001', description: 'TF1-HOUSING;M-2 SSD MODULE,S410G4-SSDC' },
          { unique_pn: '4129145C0001', description: 'TF1-FPC ASSY;MXM TO LAN FPC,S410G4-C' },
          { unique_pn: '3169145C0004', description: 'TF1 - TH - PCB; PWA - S410G4 - C, SATA SSD BD, 6L, OSP' },
          { unique_pn: '3169145C0003', description: 'TF1 - TH - PCB; PWA - S410G4 - C, SATA' }
        ],
        uniqueCompoPnToAdd: '',
        selectedCategory: [],
        displayCustomWeight: '',
        categoryWeightMappingDic:
        {
          'SW Related': 0,
          'SW Related (Outsource Required)': 2,
          'Labelling': 0,
          'Installation Service': 0,
          'Branding': 0,
          'Local Certificate only': 2,
          'Global Certificate': 2,
          'Create New Accessory': 4,
          'MIT Key Components': 0,
          'Component Removed (Strategy Functional Removal)': 0,
          'Component Removed (Create New PN/BOM Only)': 3,
          'Component Removed (Conduct C-Test Required)': 4,
        },

        categoryOptions: [
          {
            text: 'SW Related',
            value: 'SW Related'
          },
          {
            text: 'SW Related (Outsource Required)',
            value: 'SW Related (Outsource Required)'
          },
          {
            text: 'Labelling',
            value: 'Labelling'
          },

          {
            text: 'Installation Service',
            value: 'Installation Service'
          },
          {
            text: 'Branding',
            value: 'Branding'
          },
          {
            text: 'Local Certificate only',
            value: 'Local Certificate only',
          },
          {
            text: 'Global Certificate',
            value: 'Global Certificate'
          },
          {
            text: 'Create New Accessory',
            value: 'Create New Accessory'
          },

          {
            text: 'Component Removed (Conduct C-Test Required)',
            value: 'Component Removed (Conduct C-Test Required)'
          },
          {
            text: 'Component Removed (Create New PN/BOM Only)',
            value: 'Component Removed (Create New PN/BOM Only)'
          },
        ]
      };
    },
    created() {
      let self = this;
    },
    computed: {
      loginUser() {
        return _.get(this.$store, 'state.username', null);
      },
      /*
      nrePage: {
        get() {
          return this.$attrs.data;
        },
        set(value) {
          this.$attrs.data = value;
        }
      },
      */

      /*
      basic_info_review: {
        get() {
          return this.nrePage.nreData.page_object.basic_info_review;
        },
        set(value) {
          this.nrePage.nreData.page_object.basic_info_review = value;
        }
      },

       */


    },
    methods: {
      getPage() {
        let self = this;

      },


    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ticket-request-form/TicketListView.vue